import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import GroupForm from "./GroupForm";
import { createGroup, loadUserGroups, searchGroups } from "../../redux/actions/groupActions";
import { isGroupNameUnique } from "../../api/groupsApi";
import Spinner from "../common/Spinner";
import $ from 'jquery';
import './Group.css';

function GroupSearch({
    user,
    groups,
    createGroup,
    loadUserGroups,
    searchGroups,
    history
}) {

    const [groupDetails, setGroupDetails] = useState({ name: "", description: "", friendlyUrl: "", private: false });
    const [sortedResults, setSortedResults] = useState({ myGroups: [], pendingGroups: [], archivedGroups: [], otherGroups: [] });
    const [noResultsMessage, setNoResultsMessage] = useState("You are not currently a member of any groups.");
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({
        pageNumber: "1",
        numberOfResults: "100",
        keywords: "",
    });

    useEffect(() => {
        if (!groups.userGroupsInitialised) {
            setProcessing(true);
            loadUserGroups()
                .then((results) => {
                    if (results.groups.length === 0) {
                        setNoResultsMessage("You are not currently a member of any groups.")
                    }
                    sortResults(results.groups);
                    setProcessing(false);
                })
        }
    }, []);

    useEffect(() => {
        let archivedGroups = [];
        groups.userGroups.map(group => {
            if (group.archived) {
                archivedGroups.push(group);
            }
        })
        setSortedResults(prevSortedResults => ({
            ...prevSortedResults,
            archivedGroups: archivedGroups,
            pendingGroups: groups.pendingGroups
        }));
        sortResults(groups.userGroups);
    }, [groups])

    function sortResults(results) {
        if (!groups.userGroupsInitialised) {
            return;
        }
        let myGroups = [];
        let otherGroups = [];

        results.map(group => {
            let userFound = false;
            groups.userGroups.map(ug => {
                if (ug.id === group.id) {
                    if (!group.archived) {
                        myGroups.push(group);
                    }
                    userFound = true;
                }
            })
            if (!userFound && !group.archived) {
                otherGroups.push(group);
            }
        })
        setSortedResults(prevSortedResults => ({
            ...prevSortedResults,
            myGroups: myGroups,
            otherGroups: otherGroups
        }));
    }

    function handleSearchChange(e) {
        var value = e.target.value

        setSearchCriteria(prevSearchCriteria => ({
            ...prevSearchCriteria,
            keywords: value
        }));
    }

    function handleSearch(e) {
        e.preventDefault();
        if (searchCriteria.keywords.trim() === "") {
            if (groups.userGroups.length === 0) {
                setNoResultsMessage("You are not currently a member of any groups.")
            }
            sortResults(groups.userGroups);
            return;
        }
        setProcessing(true);
        searchGroups(searchCriteria)
            .then((groups) => {
                if (groups.results.length == 0) {
                    setNoResultsMessage(`There are no results for "${searchCriteria.keywords}"`)
                }
                sortResults(groups.results);
                setProcessing(false);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Search failed.. ${error.message}`);
            });
    }


    function handleSaveChange(e) {
        var { name, value } = e.target;
        if (name === "private") {
            value = e.target.checked;
        }
        setGroupDetails(prevGroupDetails => ({
            ...prevGroupDetails,
            [name]: value
        }));
    }

    function onSave(e) {
        e.preventDefault();
        const errors = {};

        if (!groupDetails.name) {
            errors.name = "A group name is required.";
            setErrors(errors);
            return;
        }

        //Do a quick call to ensure group name is unique here!

        isGroupNameUnique(groupDetails.id, groupDetails.name, groupDetails.friendlyUrl)
            .then(results => {
                if (!results.nameUnique) {
                    errors.name = "This group name already exists";
                }

                if (!results.friendlyUrlUnique) {
                    errors.friendlyUrl = "URL already in use";
                }

                if (!results.friendlyUrlUnique || !results.nameUnique) {
                    setErrors(errors);
                    return;
                }

                $('#newGroup').modal('hide')
                setProcessing(true);
                groupDetails.avatarAvailable = false;

                sumbitSave(groupDetails);
            })
    }

    function sumbitSave(groupDetails) {
        createGroup(groupDetails)
            .then((group) => {
                setProcessing(false);
                toast.success(`Group Created: ${group.name}`);
                history.push(`/groups/${group.id}`);
            })
            .catch(error => {
                setProcessing(false);
                $('#newGroup').modal('show')
                setErrors({ onSave: error.message });
            });
    }


    function onCancelSave(e) {
        e.preventDefault();
        $('#newGroup').modal('hide')
    }

    function getGroupTypeBadge(type) {
        switch (type) {
            case "Public":
                return "fas fa-lock-open";
            case "PublicClosed":
                return "fas fa-lock";
            case "Private":
                return "fas fa-eye-slash";
            default:
                return "fas fa-question";
        }
    }

    return (
        <div className="group-search col-12">
            <div className="search-toolbar top-form">
                <div className="search-input" >
                    <form onSubmit={handleSearch} >
                        <div className="input-group">
                            <input type="text" className="form-control form-control-sm" value={searchCriteria.keywords} onChange={handleSearchChange} placeholder="Search Groups..." aria-label="Keyword Search" />
                            <div className="input-group-append">
                                <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={handleSearch}></span></button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="new-group">
                    <div className="input-group">
                        <button className="btn btn-sm btn-info" data-toggle="modal" data-target="#newGroup">Create Group</button>
                    </div>
                </div>
            </div>
            {processing ?
                <Spinner /> :
                <React.Fragment>
                    {(sortedResults.otherGroups.length === 0 && sortedResults.myGroups.length === 0) &&
                        <div className="group-results-others group-results">
                            <div className="empty-message">
                                <span className="fas fa-users empty-icon"></span>
                                <div className="empty-text">{noResultsMessage}</div>
                            </div>
                        </div>
                    }
                    {sortedResults.otherGroups.length > 0 &&
                        <div className="group-results-others group-results">
                            <div className="group-results-header">All Groups</div>
                            <ul className="mt-3">
                                {
                                    sortedResults.otherGroups.map((group, index) => {
                                        return (
                                            <li className="group-link" key={group.id}>
                                                <Link to={`/groups/${group.friendlyUrl ? group.friendlyUrl : group.id}`} >
                                                    {
                                                        group.avatarAvailable ?
                                                            <UserAvatar className="group-avatar-default" size="75" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                                            :
                                                            <div className="group-avatar-default"><span className="fas fa-users" /></div>
                                                    }
                                                    <div className={`group-badge ${group.access.toLowerCase()}`}><span className={getGroupTypeBadge(group.access)}></span></div>
                                                    <div>{group.name}</div>
                                                </Link>
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    }
                    {sortedResults.myGroups.length > 0 &&
                        <div className="group-results-member group-results">
                            <div className="group-results-header">Your Groups</div>
                            <ul className="mt-3">
                                {
                                    sortedResults.myGroups.map((group, index) => {
                                        return (
                                            <li className="group-link" key={group.id}>
                                                <Link to={`/groups/${group.friendlyUrl ? group.friendlyUrl : group.id}`} >
                                                    {
                                                        group.avatarAvailable ?
                                                            <UserAvatar className="group-avatar-default" size="75" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                                            :
                                                            <div className="group-avatar-default"><span className="fas fa-users" /></div>
                                                    }
                                                    <div className={`group-badge ${group.access.toLowerCase()}`}><span className={getGroupTypeBadge(group.access)}></span></div>
                                                    <div>{group.name}</div>
                                                </Link>
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    }
                    {sortedResults.pendingGroups.length > 0 &&
                        <div className="group-results-pending group-results">
                            <div className="group-results-header">Pending Groups</div>
                            <ul className="mt-3">
                                {
                                    sortedResults.pendingGroups.map((group, index) => {
                                        return (
                                            <li className="group-link" key={group.id}>
                                                <Link to={`/groups/${group.friendlyUrl ? group.friendlyUrl : group.id}`} >
                                                    {
                                                        group.avatarAvailable ?
                                                            <UserAvatar className="group-avatar-default" size="75" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                                            :
                                                            <div className="group-avatar-default"><span className="fas fa-users" /></div>
                                                    }
                                                    <div className={`group-badge ${group.access.toLowerCase()}`}><span className={getGroupTypeBadge(group.access)}></span></div>
                                                    <div>{group.name}</div>
                                                </Link>
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    }
                    {sortedResults.archivedGroups.length > 0 &&
                        <div className="group-results-archived group-results">
                            <div className="group-results-header">Archived Groups</div>
                            <ul className="mt-3">
                                {
                                    sortedResults.archivedGroups.map((group, index) => {
                                        return (
                                            <li className="group-link" key={group.id}>
                                                <Link to={`/groups/${group.friendlyUrl ? group.friendlyUrl : group.id}`} >
                                                    {
                                                        group.avatarAvailable ?
                                                            <UserAvatar className="group-avatar-default" size="75" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                                            :
                                                            <div className="group-avatar-default"><span className="fas fa-users" /></div>
                                                    }
                                                    <div className={`group-badge ${group.access.toLowerCase()}`}><span className={getGroupTypeBadge(group.access)}></span></div>
                                                    <div>{group.name}</div>
                                                </Link>
                                            </li>
                                        );
                                    })}
                            </ul>
                        </div>
                    }
                    <div className="modal fade" id="newGroup" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                    <h5 className="modal-title">Create a New Group</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <GroupForm
                                        group={groupDetails}
                                        errors={errors}
                                        onChange={handleSaveChange}
                                        onSave={onSave}
                                        onCancel={onCancelSave}
                                        processing={processing}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            }
            </div>  
        );

}

GroupSearch.propTypes =
    {
        user: PropTypes.object.isRequired,
        groups: PropTypes.object.isRequired,
        createGroup: PropTypes.func.isRequired,
        loadUserGroups: PropTypes.func.isRequired,
        searchGroups: PropTypes.func.isRequired,
        errorMessage: PropTypes.string
    }


function mapStateToProps(state) {
    return {
        user: state.user,
        groups: state.groups
    };
}

const mapDispatchToProps = {
    createGroup,
    loadUserGroups,
    searchGroups
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupSearch)); 


// WEBPACK FOOTER //
// ./src/components/groups/GroupSearch.js